
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Footer',
    setup() {
        let year = new Date().getFullYear()

        return {
            year,
        }
    },
})
